// @flow

import React, { type Node } from 'react';
import { TipsBox } from './tips-box';
import smartphoneTipSrc from './tip-smartphone.svg';
import downloadTipSrc from './tip-download.svg';
import printTipSrc from './tip-print.svg';

export function BoletoTipsBox(): Node {
  return (
    <TipsBox title="Como pagar?" tipsModel={[
      {
        imgSrc: smartphoneTipSrc,
        altText: 'smartphone icon',
        tipText: 'Utilize o botão “copiar código” para copiar e pagar com o aplicativo do seu banco.',
      },
      {
        imgSrc: downloadTipSrc,
        altText: 'download icon',
        tipText: 'Salve seu boleto e escaneie o código de barras com o aplicativo do seu banco.',
      },
      {
        imgSrc: printTipSrc,
        altText: 'print icon',
        tipText: 'Imprima e pague o boleto em uma lotérica, aplicativo do banco ou caixa eletrônico.',
      },
    ]}
    />
  );
}
